import { logEditor } from '../state/console.js';
import { useAgents } from '../state/agents.js';
import { useTeam } from '../state/team.js';
import { useWorkspace } from '../state/workspace.js';

/**
 * Send a request to the Assistant from anywhere in the editor (model prompt
 * bar, "Ask AI to fix"), and bring the AI panel forward so the reply is seen.
 */
export async function askAssistant(text: string): Promise<boolean> {
  const { projectId, setAiOpen, view, setView } = useWorkspace.getState();
  if (!projectId || !text.trim()) return false;
  const assistant = useTeam.getState().members.find((m) => m.role === 'assistant');
  if (!assistant) {
    logEditor('warn', "Prisma is getting ready. Try again in a moment.");
    return false;
  }
  if (!['scene', 'model', 'pixel', 'sound', 'video', 'play', 'code'].includes(view)) setView('scene');
  setAiOpen(true);
  useAgents.getState().setActiveChat(assistant.id);
  try {
    await useAgents.getState().sendToMember(projectId, assistant.id, text);
    return true;
  } catch (error) {
    logEditor('error', `Could not reach Prisma: ${error instanceof Error ? error.message : error}`);
    return false;
  }
}
